import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { AddressFormFormikSAP } from "..";

import { Box } from "shipnow-mercurio";

import { isValidAddress } from "../../../address/utils/addressValidations.utils";
import { parseGeocoder } from "../../../address/services/geocoder.requests";

import { KEYBOARD_DEBOUNCE } from "../../../common/constants/settings.consts";

const DEFAULT_PROPS = {
  buyerAddress: null,
  setBuyerAddress: null,
  order: null,
};

export const FormSAP = (props) => {
  const attrs = { ...DEFAULT_PROPS, ...props };

  const refDebounce = useRef(null);

  useEffect(() => {
    let active = true;
    const analyzeAddress = (active) => {
      if (!attrs.order) return;

      if (isValidAddress(attrs.buyerAddress)) {
        parseGeocoder(attrs.buyerAddress).then((result) => {
          const data = result.results;
          if (active) {
            if (data && data.lat) {
              attrs.setBuyerAddress((prev) => ({
                ...prev,
                lat: data.lat,
                lon: data.lon,
              }));
            } else {
              attrs.setBuyerAddress((prev) => ({
                ...prev,
                lat: null,
                lon: null,
              }));
            }
          }
        });
      }
    };

    if (refDebounce.current) {
      clearTimeout(refDebounce.current);
    }

    refDebounce.current = setTimeout(() => {
      analyzeAddress(active);
    }, KEYBOARD_DEBOUNCE);
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    attrs.buyerAddress.state,
    attrs.buyerAddress.zip_code,
    attrs.buyerAddress.street_name,
    attrs.buyerAddress.street_number,
    attrs.buyerAddress.city,
  ]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    attrs.setBuyerAddress((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "zip_code") {
      if (attrs.order.buyerInfo[name] === value) return;

      attrs.order.shipping_option.service_code = null;
      attrs.order.buyerInfo["address_line"] = null;
      attrs.order.buyerInfo.post_office_id = null;
      attrs.order.buyerInfo[name] = value;

      attrs.order.shipping_option.carrier_code = null;

      attrs.order.shipping_option.tax_price = null;
      attrs.order.shipping_option.price = null;
    }
  };

  return (
    <Box margin="t-24">
      <AddressFormFormikSAP onChange={handleChange} />
    </Box>
  );
};

FormSAP.propTypes = {
  buyerAddress: PropTypes.object,
  setBuyerAddress: PropTypes.func,
  order: PropTypes.object,
};
